/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HomeMeetingDoc = {
    id: string;
    title: string;
    kind: HomeMeetingDoc.kind;
};

export namespace HomeMeetingDoc {

    export enum kind {
        PAPER = 'paper',
        FILE = 'file',
    }


}

